import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import {
  ClientResolver,
  CoursesResolver,
  DistributorResolver,
  ItinerariesResolver,
  AgentsCacheResolver,
  CountriesResolver,
  LocalesResolver,
  PlansResolver
} from 'core/resolvers';
import { KeplerMatchResolver } from '../kepler/resolvers/kepler-match.resolver';
import { DashboardResolver } from '../dashboard/dashboard.resolver';
import { ClientsComponent } from './clients/clients.component';
import { ClientCreateComponent } from './client-create/client-create.component';
import { ClientDetailComponent } from './client-detail/client-detail.component';
import { ClientSubscriptionsComponent } from './client-subscriptions/client-subscriptions.component';
import { ClientKeplerMatchComponent } from './client-kepler-match/client-kepler-match.component';

const clientsRoutes: Routes = [
  {
    path: 'clients',
    title: 'parentClients',
    resolve: {
      countries: CountriesResolver,
      agentsCache: AgentsCacheResolver,
      locales: LocalesResolver,
      plans: PlansResolver
    },
    data: { scope: 'corporate' },
    children: [
      {
        path: '',
        title: 'clients',
        component: ClientsComponent,
        canActivate: [ProfileGuard],
        data: { action: 'clients.list' }
      },
      {
        path: 'new',
        title: 'newClient',
        component: ClientCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'clients.create' },
        resolve: { distributor: DistributorResolver }
      },
      {
        path: ':clientId',
        title: 'clientIdDetail',
        component: ClientDetailComponent,
        canActivate: [ProfileGuard],
        data: { action: 'clients.detail', refreshCoursesCache: true, preloader: 'secondary' },
        resolve: {
          client: ClientResolver,
          courses: CoursesResolver,
          itineraries: ItinerariesResolver,
          dashboard: DashboardResolver
        },
        runGuardsAndResolvers: 'always'
      },
      {
        path: ':clientId/kepler/:matchId',
        title: 'keplerMatchIdClientId',
        component: ClientKeplerMatchComponent,
        canActivate: [ProfileGuard],
        resolve: {
          client: ClientResolver,
          keplerMatch: KeplerMatchResolver
        },
        data: {
          action: 'kepler.detail',
          reuseRouteComponent: false,
          preloader: 'secondary'
        }
      },
      // TODO: Clean??
      {
        path: 'subscriptions/:clientId',
        title: 'subscriptionClientId',
        component: ClientSubscriptionsComponent,
        data: { action: 'subscriptions.list' },
        canActivate: [ProfileGuard],
        resolve: {
          client: ClientResolver
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(clientsRoutes)],
  exports: [RouterModule]
})
export class ClientsRoutingModule {}
